<template>
  <b-dropdown
    v-if="showMenu"
    :id="dropDownId"
    toggle-class="btn-default"
    class="dropdown transport-button"
    menu-class="width-max-content"
    @show="setZIndex"
    @hide="unsetZIndex"
    @dblclick.native.stop
    right
    ref="dropdown"
  >
    <template #button-content>
      <i class="fa fa-bars"/>
    </template>
    <slot name="prevItems"></slot>

    <b-dropdown-item v-if="visibleTransportIssuePassButton" @click="issuePass">
      <dropdown-image icon-name="v_pass.svg" />
      Выдать пропуск
    </b-dropdown-item>

    <b-dropdown-item v-if="visibleTransportPrintPassButton" @click="givePdfPass(isGivePassPeriod)">
      <dropdown-image icon-name="v_print.svg" />
      Распечатать пропуск
    </b-dropdown-item>

    <b-dropdown-item v-if="visibleTransportSendToSolvoButton" @click="sendSolvoXml">
      <dropdown-image icon-name="v_solvo.svg" />
      Передать в Solvo.TOS
    </b-dropdown-item>

    <b-dropdown-item v-if="visibleTransportSendToSkudButton" @click="sendScudXml">
      <dropdown-image icon-name="v_skud.svg" />
      Передать в СКУД
    </b-dropdown-item>

    <slot name="lastItems"></slot>
  </b-dropdown>
</template>

<script>
import applicationFormMixin from '../../mixins/applicationFormMixin'
import { ApiClient } from '../../helpers/api-client/ApiClient'
import transportsBlockMixin from '../../mixins/application-form/transportsBlockMixin'
import actionListMenuMixin from '../../mixins/actionListMenuMixin'
import DropdownImage from './menu-components/DropdownImage.vue'

export default {
  name: 'TransportActionListMenu',

  components: { DropdownImage },

  mixins: [
    actionListMenuMixin,
    applicationFormMixin,
    transportsBlockMixin
  ],

  props: {
    applicationId: Number,
    applicationKey: {
      type: Number,
      required: true
    },
    baseUrl: String,
    transport: {
      type: Object,
      required: true
    },
    transportIndex: {
      type: Number,
      required: true
    },
    visitor: {
      type: Object,
      default: () => {}
    },
    visitorKey: {
      type: Number,
      required: true
    }
  },

  data: () => {
    return {
      status: null,
      cfgMenuTransport: []
    }
  },

  computed: {
    dropDownId() {
      return `transport-dropdown-${this.visitorKey}-${this.applicationKey}-${this.transportIndex}`
    },

    isGivePassPeriod() {
      return !!this.cfgMenuTransport.give_pass_period
    },

    personalId() {
      return Number(this.visitor.personal.id)
    },

    showMenu() {
      return Boolean(
        this.visibleTransportIssuePassButton ||
        this.visibleTransportPrintPassButton ||
        this.visibleTransportSendToSkudButton ||
        this.visibleTransportSendToSolvoButton
      )
    },

    transportId() {
      return Number(this.transport.id)
    }
  },

  created() {
    this.fetchCfgMenuTransport()
  },

  methods: {
    fetchCfgMenuTransport() {
      ApiClient.cfgMenuData({
        id: this.applicationId,
        type: 'transport'
      }).then((response) => {
        this.cfgMenuTransport = response.data.data
      })
    },

    async givePdfPass(isGivePassPeriod) {
      const pdfPassBlobResponse = await ApiClient.getPass(
        this.applicationId,
        this.visitor.personal.id,
        this.transport.id,
        isGivePassPeriod
      )
      this.openPdfInNewTab(pdfPassBlobResponse.data)
    },

    issuePass() {
      ApiClient.issuePass({
        visitor_id: this.personalId,
        transportId: this.transport.id,
        appId: this.applicationId
      }).then((result) => {
        if (result && result.data.status === 'success') {
          this.transport.isIssued = true
          this.givePdfPass(this.isGivePassPeriod)
        }
      }).catch(function () {
        alert('Не удалость выдать пропуск.')
      })
    }
  }
}
</script>
